import { AvailableLocale } from '@omnea-digital/toolbox'
import i18next, { Resource, ResourceLanguage, type i18n } from 'i18next'
import {
  FALLBACK_LANGUAGE,
  defaultNS,
  i18nextFallbackResources,
} from '@omnea-app/packages/universal/i18n/i18nextFallbackResources'

export const getTranslationsJson = async (locale: AvailableLocale): Promise<Record<string, string>> => {
  try {
    const domain = process.env.TRANSLATION_HOST_DOMAIN
    if (!domain) return {}

    const latestTranslation = await fetch(`https://${domain}/${locale}/omnea-app.json`)
    const json = await latestTranslation.json()

    // S3 can return HTML if the file is not found
    if (latestTranslation.status >= 400 || !json || typeof json !== 'object') return {}
    return json
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const createI18nInstanceWithFallbackResources = (
  locale: AvailableLocale,
  latestTranslation: ResourceLanguage | undefined
): i18n => {
  return createI18nInstance(locale, {
    [FALLBACK_LANGUAGE]: i18nextFallbackResources,
    [locale]: latestTranslation ?? {},
  })
}

export const createI18nInstance = (locale: AvailableLocale, resources: Resource): i18n => {
  const i18nextInstance = i18next.createInstance({
    resources,
    lng: locale,
    // Config translation instances have no `en` bundle, so misses still use the caller's defaultValue.
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS,
    returnNull: false,
    returnObjects: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    initAsync: false,
  })

  // Initialise the i18n instance but don't wait for it
  i18nextInstance.init().catch((error) => {
    console.error(error)
  })

  return i18nextInstance
}
